import { Actions, ActionTypes } from './actions';
import { initialState, State } from './state';

export function loginReducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.LOGIN_REQUEST_PREMIUM:
      return {
        ...state,
        error: null,
        isLoading: true,
      };
    case ActionTypes.LOGIN_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: true,
      };
    case ActionTypes.LOGIN_SUCCESS_PREMIUM:
      return {
        ...state,
        data: action.payload,
      };
    case ActionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };
    case ActionTypes.LOGIN_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        isLoading: false,
      };
    case ActionTypes.LOGOUT_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    case ActionTypes.CONNECTION_REQUEST:
      return {
        ...state,
      };
    case ActionTypes.CONNECTION_SUCCESS:
      return {
        ...state,
        connectionCount: action.payload,
      };
    case ActionTypes.CONNECTION_LOGOUT:
      return {
        ...state,
        connectionCount: null,
      };
    default: {
      return state;
    }
  }
}
